import { openBlock as t, createElementBlock as h, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ a('<path fill="#FF9811" d="M0 3.478v33.044V3.478Z"></path><path fill="#FFDA44" d="M20 40c11.045 0 20-8.954 20-20S31.045 0 20 0C8.954 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#FF9811" d="M15.652 3.478H8.728c-.307.21-.608.428-.902.654L6.087 20l1.74 15.867c.293.227.594.445.9.655h6.925V3.478Z"></path><path fill="#6DA544" d="M0 20c0 6.465 3.068 12.211 7.826 15.867V4.132C3.068 7.79 0 13.536 0 20Z"></path><path fill="#FFDA44" d="M32.174 12.193v.5l.019.003-.02-.503Z"></path><path fill="#A2001D" d="M38.406 25.217h-3.768l-1.594 1.74v3.478h-3.479v-1.74h1.74v-3.478h-7.827v2.174H21.74v-4.143a2.602 2.602 0 0 1-.87-1.944V10a2.609 2.609 0 0 1 2.61-2.609v16.087h3.477l1.194-.994a4.159 4.159 0 0 1-.324-1.614v-2.61h-2.609v-5.216h5.218c0-.87 1.304-1.74 1.304-1.74s1.305.87 1.305 1.74v5.217c.967.012 2.504-.014 4.165 0a5.275 5.275 0 0 1-.687-2.609 5.2 5.2 0 0 1 1.717-3.868 20.08 20.08 0 0 0-6.967-8.306H18.261v33.044h13.012a20.045 20.045 0 0 0 7.82-10.554l-.687-.75Z"></path>', 6), c = [
  e
];
function o(p, i) {
  return t(), h("svg", l, [...c]);
}
const v = { render: o };
export {
  v as default,
  o as render
};
